// extracted by mini-css-extract-plugin
module.exports = {"live_img":"Assets_live_img__3ZyT4","blink":"Assets_blink__2NMrA"};